import { ExtSearchService } from "../../../../../services/ext-search/ext-search.service";
import { QueryBuilderConfig } from "angular2-query-builder";
import { DataTable } from "primeng/primeng";
import { DatePipe } from "@angular/common";
import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  OnChanges,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../../../../services/user/auth.service";
import { Observable } from "rxjs/Rx";
import { ConfirmationService, MessageService, SortEvent } from "primeng/api";
import { UsersService } from "../../../../../services/user/users.service";
import { Permission } from "../../../../../models/permission.model";
import { Report } from "app/models/report.model";
import { LoyaltyChannelService } from "../../../../../services/loyalty/loyalty-channel.service";
import { StoreCommonService } from "../../../../../services/store/store-common.service";
import { LoyaltyClusterService } from "../../../../../services/loyalty/loyalty-cluster.service";
import * as moment from "moment";
import {
  CRUDNames,
  Column,
  Filter,
} from "app/modules/UIKit/components/kontable/utility/utility-model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { ChallengeService } from "app/views/challenge/challenge.service";
import {
  ChallengeDetail,
  ChallengeDetailElaborated,
} from "app/views/challenge/challenge.model";

// this is for jQuery
declare var $: any;

export interface KontableParametricSearch {
  isActive: boolean;
  searchKey: string;
  searchValue: string;
}

export interface ReachedLevel {
  id: number,
  flagPushNotification: string,
  pushNotificationText: string,
  levelAchievementDate: Date,
  description: string,
  levelReached: number,
  longDesc: string
}
@Component({
  selector: "app-challenge-3-kontable",
  templateUrl: "./challenge-3-kontable.component.html",
  styleUrls: ["./challenge-3-kontable.component.css"],
})
export class Challenge3KontableComponent implements OnInit, OnChanges {
  @Input("customerId") customerId: string;


  public static signalDataChange: EventEmitter<any> = new EventEmitter<any>();

  public static StandardLayout = "standard";

  public static NoPagination = 0;
  public static ClientPagination = 1;
  public static ServerPagination = 2;

  public static NoFilter = 0;
  public static TextFilter = 1;
  public static SelectFilter = 2;
  public static MultiselectFilter = 4;
  public static CustomFilter = 5;
  public static NumberFilter = 6;
  public static DateFilter = 7;

  public static UnknownType = "unknown";
  public static IntegerType = "integer";
  public static CurrencyType = "currency";
  public static StringType = "string";

  // begin variabili usate solo in  template per problemi di reference variabili static; todo: trovare il modo di eliminarle
  public serverPagination = Challenge3KontableComponent.ServerPagination;
  public textFilter = Challenge3KontableComponent.TextFilter;
  public numberFilter = Challenge3KontableComponent.NumberFilter;
  public selectFilter = Challenge3KontableComponent.SelectFilter;
  public multiselectFilter = Challenge3KontableComponent.MultiselectFilter;
  public customFilter = Challenge3KontableComponent.CustomFilter;
  public standardLayout = Challenge3KontableComponent.StandardLayout;
  public noPagination = Challenge3KontableComponent.NoPagination;
  public dateFilter = Challenge3KontableComponent.DateFilter;

  public konReport: Report;

  private refreshCounter = 0;

  public showReportButton = -1; //imposto la variabile a -1: mi baso sull'input della kontable figlia ->[showReport]=false/true
  // end variabili usate solo in  template per problemi di reference variabili static; todo: trovare il modo di eliminarle

  // https://blog.angular-university.io/angular-ng-template-ng-container-ngtemplateoutlet/
  @Input() additionalRowCommands: TemplateRef<any>;
  @Input() infoDialogBodyTemplate: TemplateRef<any>;
  @Input() layout: string = Challenge3KontableComponent.StandardLayout;
  @Input() title: string;
  @Input() columns: any;
  @Input() orderable: boolean = true;
  @Input() titles: Array<string>;
  @Input() paginationType: number =
    Challenge3KontableComponent.ClientPagination;

  /* modifico la logica per distinguere se viene chiamato da azioni o da campagne */

  @Input() subjectToLoad: String;
  @Input() service: any;
  @Input() methodsNames: CRUDNames = {
    list: "list",
    sendExtSearchQuery: "sendExtSearchQuery",
  };
  @Input() rowSelected = { identifierField: "id", arrayValues: [] };

  //Nuovo parametro aggiunto in fase 2 per permettere alla Kontable di fare ricerce parametriche
  //se valorizzato contiene 3 valori; booleano per capire se è parametrico o no e chiave e valore da utilizzare
  @Input() kontableParametricSearch: KontableParametricSearch;

  @Input() propertyPrefix = "";
  @Input() source: any;
  @Input() searchDelay = 400;
  @Input() searchMinLen = 3;
  @Input() rowsPerPage: number;
  @Input() rowsPerPageOptions: Array<number>;
  @Input() showGlobalFilter = true;
  @Input() showIncludeDeleted = false;
  @Input() sortableColumns: boolean;
  @Input() searchableColumns: boolean;
  @Input() columnFiltersEnabled = true;
  @Input() page: number;
  @Input() showAddButton = false;
  @Input() alternateRows = true;
  @Input() showEditButton = true;
  @Input() showDeleteButton = true;
  @Input() showInfoButton = true;
  @Input() showRecoverButton = true;
  @Input() showRolesButton = false;
  @Input() showDetailsButton = true;
  @Input() showTotalPages = true;
  @Input() showTotalRecord = true;
  @Input() showSelectButton = false; //per la multiselezione
  @Input() allowSelectCheckbox = false;
  @Input() allowSelectRow = false; //per la singola selezione del record
  @Input() defaultRowsPerPageOptions = [5, 10, 20, 50, 100];
  @Input() fixedFilters = [];
  @Input() fireNewDataAvailable = false;
  @Input() servicePermissions: Permission;
  @Input() toolbarCustomButtons: TemplateRef<any>;
  @Input() name: string;
  @Input() showCardHomingBtns = false;
  // Attiva i filtri per singola colonna. Se false, mostra il tasto "Applica Filtri" per filtraggio simultaneo di tutte le colonne
  @Input() filterBySingleColumn = true;
  @Input() showTableHeader = true;

  // Button reset filtri
  @Input() showResetFiltersBtn = true;

  // Aggiunge o toglie la colonna di button delle row (button edit, delete, info... ecc...), default true
  @Input() showRowButtons = true;

  exportReportRows: any;
  // Extended Search
  extSearchQuery: any;
  extSearchConfig: QueryBuilderConfig;
  extSearchSortField: string;
  extSearchSortDir: number;
  filteredByExtSearch = false;

  @Input() showExtSearch = false;
  @Input() extSearchConfigKey: string;
  @Input() extSearchResult: any;
  @Output() extSearchReq: EventEmitter<any> = new EventEmitter();

  @Output() onAdd = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() onInfo = new EventEmitter();
  @Output() onDetails = new EventEmitter();
  @Output() onRemove = new EventEmitter<any>();
  @Output() onRecover = new EventEmitter<any>();
  @Output() onCancelDetail = new EventEmitter();
  @Output() selectedItemChange = new EventEmitter();
  @Output() includeDeletedChange = new EventEmitter<any>();
  @Output() fireNewDataAvailableChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() cardHomingOperationType: EventEmitter<string> = new EventEmitter();
  @Output() manageRolesSelected: EventEmitter<any> = new EventEmitter();
  @Output() onDownloadExcel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRefresh = new EventEmitter();
  // Pulizia Filtri (utilizzato per filtri Data)
  @Output() onClearFilters: EventEmitter<any> = new EventEmitter<any>();

  @Output() onTableRendered: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  // Conferma Prenotazioni Premi
  @Input() showConfirmGiftsBtn = false;
  @Output() onConfirmGifts: EventEmitter<any> = new EventEmitter<any>();

  @Output() onSelected: EventEmitter<Array<any>> = new EventEmitter<
    Array<any>
  >();

  @ViewChild("childViewer") childViewer = ElementRef;
  @ViewChild("dt") dataTable: DataTable;
  @Input() DefaultRowsPerPage = 10;

  selectedItem: any;
  searchTimeout: any;

  cols: Array<Column>;
  filter: Filter;
  orderBy: Array<{ type: string; key: string }> = new Array<{
    type: string;
    key: string;
  }>();
  data: Array<any>;
  filteredData: Array<any>;
  @Input() totalRecords: number;
  totalPages: number;
  showConfirmActionDialog = false;

  currentInfo: any;
  showInfo = false;
  includeDeleted = false;
  globalFilter: string;
  translations: any;

  showMeReport = false;

  viewer: any;

  emitter = new EventEmitter<any>();

  dialogExists = false;

  openExtSearch = false;
  //aggiunte GF
  @Input() expandTable: boolean = false;
  @Input() fetchActionListAsap: boolean = false;
  @Input() fetchAcmListAsap: boolean = false;
  @Input() fetchChallengeListAsap: boolean = false;
  @Input() fetchDistributionListDetailListAsap: boolean = false;
  @Input() fetchNothing: boolean = false;

  @Input() filterStartDate;
  @Input() filterEndDate;
  campaignActions: Object;
  currentOpenedRow: any = null;
  selectAllModel: boolean = false;
  loadedActionTable: boolean = false;

  @Input() customExpandedRowTemplate: TemplateRef<any>;
  @Output() onRowExpanded: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    public srvCalendar: CalendarTranslateService,
    private usersSrv: UsersService,
    private srvNotify: MessageService,
    private datePipe: DatePipe,
    private extSearchService: ExtSearchService,
    private channelService: LoyaltyChannelService,
    private storeCommonService: StoreCommonService,
    private clusterService: LoyaltyClusterService,
    private challengeService: ChallengeService
  ) {
    let self = this;
    this.translate
      .get([
        "kontable.delete",
        "kontable.recoverConfirmation",
        "kontable.removeConfirmation",
        "kontable.noInfoData",
      ])
      .subscribe((res) => {
        self.translations = res;
      });
    Challenge3KontableComponent.signalDataChange.subscribe((change) => {
      if (change.name === this.name) {
        this.ngOnInit();
      }
    });
  }

  // fixme MAH.
  t(text: string) {
    return text;
  }

  // fixme MAH2.
  format(value: any, type: string, translate = false) {
    switch (type) {
      case Challenge3KontableComponent.CurrencyType: {
        if (typeof value !== "number") {
          value = <number>value;
        }
        return Math.floor(value * 100) / 100;
      }

      // fixme MAH3.
      default: {
        if (translate) {
          return this.t(value);
        }
        return value;
      }
    }
  }
  onClickRow(index: number, item: any, event: boolean) {
    item.rowSelected = !item.rowSelected;
    this.onSelected.emit(item);
  }
  onSelect(item: any) {
    this.onSelected.emit(item);
  }
  onSelectAll() {
    for (let row of this.filteredData) {
      console.log('row', row);
      row.rowSelected = this.selectAllModel;
      this.onSelected.emit(row);
    }
  }
  clientSideFilter() {
    if (this.filter) {
      let gFilter =
        this.globalFilter == null ? "" : this.globalFilter.toLowerCase();

      this.filteredData = this.data.filter((r) => {
        if ((!gFilter || gFilter === "") && this.filter.search.length === 0) {
          return true;
        }

        // Implementare filtraggio e ordinamento
        let globalFilterOk = !gFilter || gFilter === "";
        let keys = Object.keys(r);
        for (let i = 0; i < keys.length; i++) {
          let k = keys[i];
          if (
            r[k] &&
            gFilter &&
            gFilter !== "" &&
            r[k].toString().toLowerCase().indexOf(gFilter) !== -1
          ) {
            globalFilterOk = true;
            break;
          }
        }

        let allColumnFilters = true;
        for (let i = 0; i < keys.length; i++) {
          let k = keys[i];

          let fieldFilter = this.filter.search.filter((s) => s.key === k);
          if (k != "id") {
            if (
              (fieldFilter.length > 0 && !r[k] && r[k] != 0) ||
              (fieldFilter.length > 0 &&
                r[k]
                  .toString()
                  .toLowerCase()
                  .indexOf(fieldFilter[0].value.toString().toLowerCase()) ===
                  -1)
            ) {
              allColumnFilters = false;
              break;
            }
          } else {
            // in caso di filtro per 'id', restituisco solo gli elementi uguali alla stringa cercata e non anche quelli che la contengono solamente
            if (
              (fieldFilter.length > 0 && !r[k] && r[k] != 0) ||
              (fieldFilter.length > 0 &&
                r[k].toString().toLowerCase() !==
                  fieldFilter[0].value.toString().toLowerCase())
            ) {
              allColumnFilters = false;
              break;
            }
          }
        }
        return allColumnFilters && globalFilterOk;
      });
      this.totalRecords = this.filteredData.length;
      this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);

      if (this.dataTable) {
        this.dataTable.first = 0; // riporto alla prima pagina dopo filtraggio colonne client side
      }
    }
  }

  globalFilterChange(key) {
    this.globalFilter = key;

    this.refresh();
  }

  // Funzione per formattare una data nel formato "yyyy-mm-gg"
private formatDate(date: Date): string {
  let result = '';

  if (date) {
    const transformed = this.datePipe.transform(date, 'yyyy-MM-dd');
    if (transformed !== null) {
      result = transformed;
    }
  }

  return result;
}

  removeFilterByKey(key: string) {
    if (this.filter) {
      const index = this.filter.search.findIndex((f) => f.key === key);
      if (index !== -1) {
        this.filter.search.splice(index, 1);
      }
    }
  }

  clearDateFilter(field: string) {
    const index = this.filter.search.findIndex((item) => item.key === field);

    if (index !== -1) {
      this.filter.search.splice(index, 1);
      // Azzerare il valore della casella di input associata
      this.filter.search[field] = null;
    }
  }

  ngOnChanges(changes) {
    if (this.filterStartDate == undefined) {
      this.removeFilterByKey("start_date");
    } else {
      const startDate = new Date(this.filterStartDate);
      const formattedStartDate = this.formatDate(startDate);

      let searchFilterDateStart = this.filter.search.filter(
        (f) => f.key === "start_date"
      );

      if (searchFilterDateStart.length > 0) {
        searchFilterDateStart[0].value = formattedStartDate;
      } else {
        this.filter.search.push({
          key: "start_date",
          value: formattedStartDate,
          filterType: "date",
        });
      }
    }

    if (this.filterEndDate == undefined) {
      this.removeFilterByKey("end_date");
    } else {
      const endDate = new Date(this.filterEndDate);
      const formattedEndDate = this.formatDate(endDate);
      let searchFilterDateEnd = this.filter.search.filter(
        (f) => f.key === "end_date"
      );

      if (searchFilterDateEnd.length > 0) {
        searchFilterDateEnd[0].value = formattedEndDate;
      } else {
        this.filter.search.push({
          key: "end_date",
          value: formattedEndDate,
          filterType: "date",
        });
      }
    }

    if (changes.extSearchResult) {
      this.filteredData = changes.extSearchResult.currentValue;
      this.totalPages = Math.ceil(this.totalRecords / 10);
    }

    let refresh = false;
    if (changes.fireNewDataAvailable) {
      this.fireNewDataAvailable = false;
      const self = this;
      setTimeout(function () {
        self.fireNewDataAvailableChange.emit(false);
      }, 100);

      refresh = true;
    } else if (changes.source) {
      refresh = true;
    }

    if (refresh) {
      this.refresh();
    }
  }

  addDefaultEventSubscribers() {
    if (!this.onInfo) {
      let self = this;
      // Default subscriber per onedit method: show detail panel (con dati...)
      this.onInfo.subscribe((evt) => {
        if (evt && evt.user_ins_id && evt.user_ins_id > 0) {
          self.loadInfo(evt).subscribe((res) => {
            if (res.error) {
              this.srvNotify.add({
                severity: "error",
                summary: "Attenzione",
                detail: res.message,
              });
            } else {
              self.showInfo = true;
              self.currentInfo = res;
            }
          });
        } else {
          self.showInfo = true;
        }
      });
    }
  }

  refresh() {
    this.filteredByExtSearch = false;
    this.data = [];

    if (this.source instanceof Array) {
      if (
        this.paginationType === Challenge3KontableComponent.ServerPagination
      ) {
        console.warn(
          "serverSide Pagination not allowed with Array Source. Switch to client side"
        );
        this.paginationType = Challenge3KontableComponent.ClientPagination;
      }

      this.data = this.source;
      if (
        this.totalRecords === undefined &&
        this.source.length !== 0 &&
        this.filter
      ) {
        this.totalRecords = this.source.length;
        this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);
      }

      this.clientSideFilter();
      var self = this;
      setTimeout(function () {
        self.onTableRendered.emit(true);
      }, 100);
    } else if (this.source instanceof Function) {
      this.source();
      //Il problema sembrerebbe qui

      if (
        this.totalRecords === undefined &&
        this.source.length !== 0 &&
        this.filter
      ) {
        this.totalRecords = this.source.length;
        this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);
      }
    } else if (this.source == null) {
      console.debug(
        "kontable source is not defined, must be an instance of an Array or a function, or you need to pass a service"
      );
    }

    this.onRefresh.emit(true);
  }

  ngOnInit() {
    if (this.showExtSearch && this.extSearchConfigKey) {
      this.extSearchService
        .getExtSearchConfig(this.extSearchConfigKey)
        .subscribe((res) => {
          if (res && res.length > 0) {
            if (!this.extSearchQuery) {
              this.extSearchQuery = res[0].configValue.query;
            }
            const configFields = res[0].configValue.QueryBuilderConfig.fields;
            const configFieldsArr = [];
            for (const prop in configFields) {
              //#region Estensione di "ExtSearchConfig" per recuperare dati extra
              if (configFields[prop].hasOwnProperty("service")) {
                const valService = configFields[prop]["service"];

                switch (valService) {
                  case "channel":
                    this.channelService.list().subscribe((resp) => {
                      for (const channel of resp.data) {
                        configFields[prop].options.push({
                          name: channel.channelDescription,
                          value: channel.id,
                        });
                      }
                    });
                    break;
                  case "store":
                    this.storeCommonService.getList().subscribe((resp) => {
                      for (const store of resp) {
                        configFields[prop].options.push({
                          name: store.name,
                          value: store.id,
                        });
                      }
                    });
                    break;
                  case "cluster":
                    this.clusterService.list().subscribe((resp) => {
                      for (const cluster of resp.data) {
                        configFields[prop].options.push({
                          name: cluster.description,
                          value: cluster.id,
                        });
                      }
                    });
                    break;
                }
              }
              //#endregion
              if (configFields[prop].hasOwnProperty("id")) {
                configFieldsArr.push({ [`${prop}`]: configFields[prop] });
              } else {
                this.extSearchConfig = res[0].configValue.QueryBuilderConfig;
                break;
              }
            }
            if (configFieldsArr.length > 0) {
              configFieldsArr.sort((a, b) => {
                const idA = a[Object.keys(a)[0]]["id"];
                const idB = b[Object.keys(b)[0]]["id"];
                let comparison = 0;
                if (idA > idB) {
                  comparison = 1;
                } else if (idA < idB) {
                  comparison = -1;
                }
                return comparison;
              });
              const configFieldsObject = { fields: {} };
              configFieldsArr.forEach((field) =>
                Object.assign(configFieldsObject.fields, field)
              );
              this.extSearchConfig = configFieldsObject;
            }
            // In caso di Extended Search Config valida imposto filtri statici
            if (this.extSearchConfig) {
              this.filterBySingleColumn = false;
            } else if (this.filterBySingleColumn) {
              this.refresh();
            }
          } else if (this.filterBySingleColumn) {
            this.refresh();
          }
        });
    }

    //this.paramsLoyService.getParamByKey('REPORT.EXPORT_ROWS').subscribe(res => this.exportReportRows = res.param_code);
    //this.addDefaultEventSubscribers();

    let toTranslate = [];
    if (typeof this.title === "string" && this.title.length > 0) {
      if (this.title.charAt(0) === "$") {
        toTranslate.push(this.title.substr(1));
      }
    }

    if (this.columns == null || this.columns.lenght === 0) {
      throw new Error("columns is a required non-empty member for kontable");
    }
    //definizione delle colonnme GF
    //TODO SE VOLESSI AGGIUNGERE I BOTTONI COLORATI DOVREI AGIUNGERE UN TIPO DI VISUALIZZAZIONE ALLA CLONNA PENSO
    this.cols = [];

    let titles_index = 0;

    this.columns.forEach((column) => {
      if (typeof column === "string" && column.length > 0) {
        let columnDef: Column = {
          field: column,
          title: null,
          titleRef: null,
          type: Challenge3KontableComponent.UnknownType,
          searchable: true,
          sortable: true,
          filterType: Challenge3KontableComponent.TextFilter,
        };
        if (titles_index < this.titles.length) {
          let t = this.titles[titles_index++];

          if (t.charAt(0) === "$") {
            columnDef.titleRef = t.substr(1);
            toTranslate.push(columnDef.titleRef);
          } else {
            columnDef.title = t;
          }
        } else {
          throw new Error("not enough titles for columns");
        }

        this.cols.push(columnDef);
      } else {
        if (column.field == null || column.field === "") {
          throw new Error("field is a required non-empty member for column");
        } else {
          let columnDef: Column = column;
          if (columnDef.title == null) {
            if (columnDef.titleRef != null) {
              toTranslate.push(columnDef.titleRef);
            } else {
              columnDef.title = column.field;
              columnDef.titleRef = null;
              console.warn(
                "kontable column needs title or titleRef defined. Missing for column " +
                  columnDef.field +
                  ". set to default (column field)"
              );
            }
          }

          if (columnDef.type == null) {
            columnDef.type = Challenge3KontableComponent.UnknownType;
          }

          if (columnDef.sortable == null) {
            columnDef.sortable = this.sortableColumns;
          }

          if (columnDef.sortable == null) {
            columnDef.sortable = true;
          }

          if (columnDef.searchable == null) {
            columnDef.searchable = this.searchableColumns;
          }

          if (columnDef.searchable == null) {
            columnDef.searchable = true;
          }

          if (columnDef.filterType == null) {
            columnDef.filterType = Challenge3KontableComponent.TextFilter;
          }

          if (
            columnDef.filterType === Challenge3KontableComponent.SelectFilter ||
            columnDef.filterType ===
              Challenge3KontableComponent.MultiselectFilter
          ) {
            if (columnDef.filterOptions != null) {
              if (columnDef.filterOptions.values == null) {
                if (columnDef.filterOptions.valuesSource == null) {
                  columnDef.filterOptions.values = [];
                  columnDef.filterOptions.values.push({
                    value: null,
                    label: "All",
                  });
                } else {
                  let labelName = "description";
                  let valueName = "description";

                  if (columnDef.filterOptions.valueName != null) {
                    valueName = columnDef.filterOptions.valueName;
                  }

                  if (columnDef.filterOptions.labelName != null) {
                    labelName = columnDef.filterOptions.labelName;
                  }

                  columnDef.filterOptions.valuesSource.subscribe((res) => {
                    columnDef.filterOptions.values = [];
                    columnDef.filterOptions.values.push({
                      value: null,
                      label: "All",
                    });

                    res.data.forEach((e) => {
                      columnDef.filterOptions.values.push({
                        value: e[valueName],
                        label: e[labelName],
                      });
                    });
                  });
                }
              }
            } else {
              columnDef.filterOptions = {};
              columnDef.filterOptions.values = [{ value: null, label: "All" }];
            }
          }
          this.cols.push(columnDef);
        }
      }
    });
    if (toTranslate.length > 0) {
      this.translate.get(toTranslate).subscribe((res) => {
        if (this.title.charAt(0) === "$") {
          this.title = res[this.title.substr(1)];
        }
        this.cols.forEach((c, index, arr) => {
          if (c.title == null) {
            if (c.titleRef != null) {
              arr[index].title = res[c.titleRef];
            }
          }
        });
      });
    }

    // Recupero filtri inseriti prima di destroy del componente
    if (this.service && sessionStorage.getItem(this.service.constructor.name)) {
      const storedFilters = JSON.parse(
        sessionStorage.getItem(this.service.constructor.name)
      );
      if ("condition" in storedFilters) {
        this.extSearchQuery = storedFilters;
        this.openExtSearch = true;
      } else {
        this.fixedFilters = storedFilters;
      }
    } else if (
      this.source instanceof Array &&
      sessionStorage.getItem(`${this.title}SourceFilters`)
    ) {
      this.fixedFilters = JSON.parse(
        sessionStorage.getItem(`${this.title}SourceFilters`)
      );
    }

    this.filter = {
      offset: 0,
      limit: 0,
      sort: "dateStart",
      sort_dir: -1,
      search: Object.assign([], this.fixedFilters),
    };

    if (this.paginationType !== Challenge3KontableComponent.NoPagination) {
      this.filter.limit = this.rowsPerPage;

      if (this.filter.limit == null) {
        this.filter.limit = this.DefaultRowsPerPage;
      }

      if (this.page != null) {
        this.filter.offset = (this.page - 1) * this.filter.offset;
      }
    } else {
      this.filter.limit = 0;
      this.filter.offset = 0;
    }

    // crea i raggruppamenti delle colonne
    if (this.service != null) {
      //CHIAMATA NON PARAMETRICA

      if (
        this.paginationType === Challenge3KontableComponent.ServerPagination &&
        !this.kontableParametricSearch
      ) {
        this.source = () => {
          this.service["getActiveChallenges"](
            this.customerId,
            this.filter.offset,
            this.filter.limit,
            this.filter.search,
            this.globalFilter,
            this.filter.sort,
            this.filter.sort_dir
          ).subscribe((res) => {
            this.data = [];

            this.totalRecords = res[this.propertyPrefix + "metadata"].total;
            this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);

            for (const single of res[this.propertyPrefix + "data"]) {
              Object.keys(single).forEach((key) => {
                /* IL SEGUENTE CODICE SERVE PER LA VISUALIZZAZIONE DELLE DATE E ORARIO NEL FORMATO CORRETTO */

                if (
                  typeof single[key] === "string" &&
                  single[key].indexOf("1970-01-01") !== -1 &&
                  (single[key].indexOf("T00:00:00.000+0000") !== -1 ||
                    single[key].indexOf("T00:00:00.000+0100") !== -1)
                ) {
                  single[key] = this.datePipe.transform(
                    single[key],
                    this.srvCalendar["calendars"][
                      this.authService.sessionHelper.selectedLanguage
                    ].dateFormatFilter
                  );
                } else if (
                  typeof single[key] === "string" &&
                  single[key].indexOf("1970-01-01") !== -1 &&
                  (single[key].indexOf("T00:00:00.000+0000") === -1 ||
                    single[key].indexOf("T00:00:00.000+0100") === -1)
                ) {
                  single[key] = this.datePipe.transform(
                    single[key],
                    "HH:mm:ss"
                  );
                } else if (
                  typeof single[key] == "string" &&
                  (single[key].indexOf("T00:00:00.000+0000") !== -1 ||
                    single[key].indexOf("T00:00:00.000+0100") !== -1)
                ) {
                  let dateNum = Date.parse(single[key]);
                  if (dateNum) {
                    single[key] = this.datePipe.transform(
                      single[key],
                      this.srvCalendar["calendars"][
                        this.authService.sessionHelper.selectedLanguage
                      ].dateFormatFilter
                    );
                  }
                }
              });
              //singolo record che viene inserito
              this.data.push(single);
            }
            this.filteredData = this.data;
            this.filteredData = this.filteredData.map((item) => ({
              ...item,
              showAdditionalRow: false,
            }));
            this.filteredData = this.data;
            this.checkForSelected(this.filteredData);
            var self = this;
            setTimeout(function () {
              self.onTableRendered.emit(true);
            }, 100);
          });
        };
      }

      //CHIAMATA PARAMETRICA
      else if (
        this.paginationType === Challenge3KontableComponent.ServerPagination &&
        this.kontableParametricSearch
      ) {
        // Aggiunta dei filtri parametrici presi in input da kontableParametricSearch
        if (
          this.kontableParametricSearch &&
          this.kontableParametricSearch.searchKey &&
          this.kontableParametricSearch.searchValue
        ) {
          this.filter.search.push({
            key: this.kontableParametricSearch.searchKey,
            value: this.kontableParametricSearch.searchValue,
          });
        } else {
          console.warn(
            "Invalid kontableParametricSearch:",
            this.kontableParametricSearch
          );
        }

        this.source = () => {
          this.service["getActiveChallenges"](
            this.customerId,
            this.filter.offset,
            this.filter.limit,
            this.filter.search,
            this.globalFilter,
            this.filter.sort,
            this.filter.sort_dir
          ).subscribe((res) => {
            this.data = [];

            this.totalRecords = res[this.propertyPrefix + "metadata"].total;
            this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);

            for (const single of res[this.propertyPrefix + "data"]) {
              Object.keys(single).forEach((key) => {
                /* IL SEGUENTE CODICE SERVE PER LA VISUALIZZAZIONE DELLE DATE E ORARIO NEL FORMATO CORRETTO */

                if (
                  typeof single[key] === "string" &&
                  single[key].indexOf("1970-01-01") !== -1 &&
                  (single[key].indexOf("T00:00:00.000+0000") !== -1 ||
                    single[key].indexOf("T00:00:00.000+0100") !== -1)
                ) {
                  single[key] = this.datePipe.transform(
                    single[key],
                    this.srvCalendar["calendars"][
                      this.authService.sessionHelper.selectedLanguage
                    ].dateFormatFilter
                  );
                } else if (
                  typeof single[key] === "string" &&
                  single[key].indexOf("1970-01-01") !== -1 &&
                  (single[key].indexOf("T00:00:00.000+0000") === -1 ||
                    single[key].indexOf("T00:00:00.000+0100") === -1)
                ) {
                  single[key] = this.datePipe.transform(
                    single[key],
                    "HH:mm:ss"
                  );
                } else if (
                  typeof single[key] == "string" &&
                  (single[key].indexOf("T00:00:00.000+0000") !== -1 ||
                    single[key].indexOf("T00:00:00.000+0100") !== -1)
                ) {
                  let dateNum = Date.parse(single[key]);
                  if (dateNum) {
                    single[key] = this.datePipe.transform(
                      single[key],
                      this.srvCalendar["calendars"][
                        this.authService.sessionHelper.selectedLanguage
                      ].dateFormatFilter
                    );
                  }
                }
              });
              //singolo record che viene inserito
              this.data.push(single);
            }
            this.filteredData = this.data;
            this.filteredData = this.filteredData.map((item) => ({
              ...item,
              showAdditionalRow: false,
            }));
            this.filteredData = this.data;
            this.checkForSelected(this.filteredData);
            var self = this;
            setTimeout(function () {
              self.onTableRendered.emit(true);
            }, 100);
          });
        };
      } else {
        this.source = () => {
          this.service["getActiveChallenges"](this.customerId).subscribe(
            (res) => {
              this.data.length = 0;
              res.data.forEach((challenge) => {
                this.data.push(challenge);
              });
              this.totalRecords = this.data.length;
              this.totalPages = Math.ceil(
                this.totalRecords / this.filter.limit
              );
              this.clientSideFilter();
              var self = this;
              setTimeout(() => {
                self.onTableRendered.emit(true);
              }, 100);
            }
          );
        };
      }
    }
    // Lascio la table vuota in caso di staticTable o di Extended Search
    if (this.filterBySingleColumn && !this.showExtSearch) {
      this.refresh();
    }
    // la permission gestisce la visualizzazione o meno del button "Visualizza report". Se la permission non è associata, si mantiene la retrocompatibilità
    // del button ossia la visualizzazione viene gestita dalle kontable "figlie" (showReportButton=-1)
    /*
    this.permSrvCommon.getCommonPermission().subscribe((permissions: Permission[]) => {
      permissions.forEach((perm: Permission) => {
        if (perm.operationName === 'show-report-btn') {
          //è presente la nuova operation in common.grant_permission e se è abilitata la GET(true) porto il showReportButton al valore 1 altrimenti(visualizzo il button in UI)
          // se la get non è abilitata ma la permission è comunque presente ed associata a quel ruolo/utente la porto a zero(ed il button non è più visibile in UI): in
          // questa casistica vado a SOVRASCRIVERE il comportamento imposto dalla kontable figlia tramite l'input showReport. Se la permission non è presente, la logica resta
          //legata alla variabile showReport ed al suo valore(defaul è true)
          if (perm.allowsGET)
            this.showReportButton = 1;
          else
            this.showReportButton = 0;
        }
      });
    });
    */
  }
  rowEvent(row, eventType) {
    // reset di alcune variabili dei default event handlers
    this.showInfo = false;
    this.selectedItem = row;
    this.showConfirmActionDialog = false;

    // propagazione eventi
    switch (eventType) {
      case "add":
        this.onAdd.emit(row);
        break;

      case "edit":
        this.onEdit.emit(row);
        break;

      case "info":
        this.onInfo.emit(row);
        break;

      case "details":
        this.onDetails.emit(row);
        break;

      case "manage-roles":
        this.manageRolesSelected.emit(row);
        break;

      case "confirm-remove":
        this.confirmationService.confirm({
          header: `${this.translations["kontable.delete"]}!`,
          message: this.translations["kontable.removeConfirmation"],
          accept: () => {
            this.onRemove.emit(row);
          },
        });
        break;

      case "confirm-recover":
        this.confirmationService.confirm({
          message: this.translations["kontable.recoverConfirmation"],
          accept: () => {
            this.onRecover.emit(row);
          },
        });
        break;
    }

    this.selectedItemChange.emit(row);
  }

  internalIncludeDeletedChanged(evt) {
    this.updateTableFilter("flg_state", evt ? "" : "0", "equals", 1, 200);

    this.includeDeletedChange.emit(evt);
  }

  loadInfo(record: any) {
    let ids = [];
    if (record.user_ins_id) {
      ids.push(record.user_ins_id);
    }
    if (record.user_upd_id) {
      ids.push(record.user_upd_id);
    }
    if (record.user_del_id) {
      ids.push(record.user_del_id);
    }

    if (ids.length > 0) {
      return new Observable<any>((observer) => {
        this.usersSrv.getFiltereIdList(ids.join(",")).subscribe((users) => {
          const ret = {};

          if (record.user_ins_id) {
            ret["userInsertInfo"] = {
              login: users.find((u) => u.id === record.user_ins_id).login,
              insert_timestamp: record.ts_ins,
            };
          }

          if (record.user_upd_id) {
            ret["userUpdateInfo"] = {
              login: users.find((u) => u.id === record.user_upd_id).login,
              update_timestamp: record.ts_upd,
            };
          }

          if (record.user_del_id) {
            ret["userDeleteInfo"] = {
              login: users.find((u) => u.id === record.user_del_id).login,
              delete_timestamp: record.ts_del,
            };
          }

          observer.next(ret);
        });
      });
    } else {
      return Observable.of({
        error: true,
        message: this.translations["kontable.noInfoData"],
      });
    }
  }

  updateTableFilter(
    field,
    value,
    filterType,
    filterChars = 1,
    timeoutSecs = 1000,
    applyFilter = false
  ) {
    this.currentOpenedRow = null;
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = null;
    }
    /*
      in caso di staticTable disattivo il timeout dei filtri in quanto
      l'utente potrebbe applicarli prima che vengano aggiunti all'array (this.filter.search)
    */
    if (!this.filterBySingleColumn) {
      timeoutSecs = 0;
    }
    if (applyFilter) {
      // eseguo la chiamata con i filtri alla pressione del button "Applica Filtri della staticTable"
      this.refresh();
    } else if (value && value.length >= filterChars) {
      this.searchTimeout = setTimeout(() => {
        let searchFilter = this.filter.search.filter((f) => f.key === field);

        if (searchFilter.length > 0) {
          searchFilter[0].value = value;
        } else {
          // KS-1496: porto a 0 l'offset del filtro lato server
          this.filter.offset = 0;

          // qui vengono aggiunti i vari filtri alla stringa
          this.filter.search.push({
            key: field,
            value: value,
            filterType: filterType,
          });
          // KS-1496 torno alla prima pagina della Kontable
          this.dataTable.first = 0;
        }
        if (this.filterBySingleColumn) {
          this.refresh(); // qui viene eseguita la chiamata con i filtri
        }

        this.searchTimeout = null;

        if (this.refreshCounter === 0) {
          this.refreshCounter++;
        }
      }, timeoutSecs);
    } else {
      let index = this.filter.search.findIndex((f) => f.key === field);
      if (index > -1) {
        this.filter.search.splice(index, 1);
      }

      if (this.refreshCounter > 0) {
        this.refreshCounter = 0;
      }

      if (this.filterBySingleColumn) {
        this.refresh();
      }
    }
  }

  clearFilters() {
    // pulisco i filtri
    //this.columns.forEach(col => this.filter.search[col.field] = null);
    let objectFilterFootprint = Object.assign(
      {},
      this.filter.search.find((x) => x.key == "footprint")
    );
    this.filter.search = [];

    if (objectFilterFootprint) {
      this.filter.search.push(objectFilterFootprint);
    }

    this.onClearFilters.emit();
    if (this.filterBySingleColumn) {
      this.refresh();
    } else {
      this.filteredData = null; // pulisco i dati della table
      this.filter.offset = 0; // porto a 0 l'offset del filtro
      this.dataTable.first = 0; // torno alla prima pagina della Kontable
      this.totalPages = 0; // azzero conto totale pagine
      this.totalRecords = 0; // azzero totale dati
    }
  }

  onPageChange(event) {
    if (this.filteredByExtSearch) {
      if (this.extSearchSortField && this.extSearchSortDir) {
        this.extSearchReq.emit({
          query: this.extSearchQuery,
          offset: event.first,
          limit: 10,
          sortField: this.extSearchSortField,
          sortDir: this.extSearchSortDir,
        });
      } else {
        this.extSearchReq.emit({
          query: this.extSearchQuery,
          offset: event.first,
          limit: 10,
        });
      }
    } else {
      this.filter.limit = event.rows;
      this.totalPages = Math.ceil(this.totalRecords / this.filter.limit);
      if (this.paginationType === KontableComponent.ServerPagination) {
        this.filter.offset = event.first;
        this.refresh();
      }
    }
  }

  onSortData(event: SortEvent) {
    if (this.paginationType === KontableComponent.ServerPagination) {
      if (this.filteredByExtSearch) {
        this.extSearchSortField = event.field;
        this.extSearchSortDir = event.order;
        this.extSearchReq.emit({
          query: this.extSearchQuery,
          offset: 0,
          limit: 10,
          sortField: this.extSearchSortField,
          sortDir: this.extSearchSortDir,
        });
      } else {
        this.filter.sort = event.field;
        this.filter.sort_dir = event.order;
        this.refresh();
      }
    }
  }

  addCustomButton(viewer) {
    const userButton = viewer.jsObject.SmallButton(
      "userButton",
      "My Button",
      "emptyImage"
    );
    userButton.image.src = "https://www.stimulsoft.com/favicon.png";
    userButton.action = () => {
      alert("My Button");
    };

    const toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
    const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
    const userButtonCell = buttonsTable.rows[0].insertCell(0);
    userButtonCell.className = "stiJsViewerClearAllStyles";
    userButtonCell.appendChild(userButton);
  }

  addCloseButton() {
    const userButton = this.viewer.jsObject.SmallButton(
      "userButton",
      "Close",
      "emptyImage"
    );
    const self = this;
    userButton.action = function () {
      self.konReport = null;
      self.showMeReport = false;
      $("body").css("overflow", "auto");
    };

    const toolbarTable =
      this.viewer.jsObject.controls.toolbar.firstChild.firstChild;
    const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
    const userButtonCell = buttonsTable.rows[0].insertCell(0);
    userButtonCell.className = "stiJsViewerClearAllStyles";
    userButtonCell.appendChild(userButton);
  }
  checkForSelected(arrayData: Array<any>) {
    if (
      this.rowSelected &&
      this.rowSelected.arrayValues &&
      this.rowSelected.arrayValues.length > 0 &&
      arrayData &&
      arrayData.length > 0
    ) {
      let id = this.rowSelected.identifierField;
      for (let row of this.rowSelected.arrayValues) {
        let rowFound = arrayData.find((x) => x[id] == row[id]);
        if (rowFound) {
          rowFound["rowSelected"] = true;
        }
      }
    }
  }
  checkAlign() {
    this.konReport.columns.forEach((column) => {
      let isNumber = true;
      this.konReport.data.forEach((data) => {
        if (data[column.field] && !Number(data[column.field].toString())) {
          isNumber = false;
        }
        if (isNumber) {
          column.alignData = "right";
        }
      });
    });
  }
  sendExtSearchQuery(event) {
    this.filteredByExtSearch = true;
    this.clearFilters();
    this.extSearchReq.emit({ query: event, offset: 0, limit: 10 });
  }

  convertDate(date: Date) {
    return moment(date).format("YYYY-MM-DD");
  }

  ngOnDestroy() {}
  loadedAccumulator = false;
  loadedDistributionListClusters = false;
  loadedChallengeTable = false;
  challengeDetailList: any;

  onExpandRow(row: any) {
    //gestire il caso in cui l'id non è uguale all'indice di tabella

    if (this.fetchDistributionListDetailListAsap) {
      if (this.currentOpenedRow === row.distributionListId) {
        // Chiudo la riga
        this.currentOpenedRow = null;
        this.loadedDistributionListClusters = false;
      } else {
        // Apro la riga
        this.currentOpenedRow = row.distributionListId;
        this.loadedDistributionListClusters = false;
        this.onRowExpanded.emit(row);

        console.log("cerco distribuzione associati ala lista");
      }
    }
    //gestire il caso in cui id = indice di tabella

    if (
      this.fetchAcmListAsap ||
      this.fetchActionListAsap ||
      this.fetchNothing ||
      this.fetchChallengeListAsap
    ) {
      console.log("questa è la rowID:", row.id);
      if (this.currentOpenedRow === row.id) {
        // Close the row
        this.currentOpenedRow = null;
        this.loadedAccumulator = false; // Ensure loadedAccumulator is reset
      } else {
        this.currentOpenedRow = row.id;
        this.loadedActionTable = false;
        this.loadedAccumulator = false; // Reset to false when expanding a new row
        this.onRowExpanded.emit(row);

        if (this.fetchChallengeListAsap) {
          console.log("cerco accumulatori associati al canale");
          this.loadedChallengeTable = true;
          this.fetchChallengeList(row);
        }
      }
    }
  }

  challengeDetailListElaborated: ChallengeDetailElaborated[] = []; 
  fetchChallengeList(row): void {
    this.challengeService.getReachedLevels(row.id, this.customerId).subscribe(
      (res: ReachedLevel[]) => {
        this.challengeDetailList = res; // dati raw
        this.currentOpenedRow = row.id;
        this.loadedChallengeTable = true;
      },
      (error) => {
        console.error("Errore durante il recupero delle sfide attive:", error);
      }
    );
  }

  // private elaborateChallengeDetails(
  //   details: ChallengeDetail[]
  //   // Bisogna verificare se i dettagli relativi agli accumulatori sono necessari o meno nella GUI 
  // ): ChallengeDetailElaborated[] {
  //   const elaborated: ChallengeDetailElaborated[] = [];
  //   details.forEach((detail) => {
  //     detail.challengeDetailAcm.forEach((acm) => {
  //       elaborated.push({
  //         id: detail.id,
  //         challengeId: detail.challengeId,
  //         levelName: detail.description,
  //         challengeDetailAcmId: acm.id,
  //         controlAcm: acm.challengeAcm.acmId.id,
  //         minimumTrashold: acm.minRangeValue,
  //         maximumTrashold: acm.maxRangeValue,
  //         pushNotify: detail.flgPushNotification,
  //         pushNotifyText: detail.pushNotificationText || "",
  //       });
  //     });
  //   });

  //   return elaborated;
  // }

  //TODO: attenzione ora funziona perchè ricerca per id non per nome!
  findAgainAction(id: number) {
    // Recupera il valore corrente dall'input di filtro del nome
    const idFilter = {
      key: "id",
      value: id.toString(),
      filterType: "contains",
    };
    this.filter.search = this.filter.search.filter((f) => f.key !== "name");
    this.filter.search.push(idFilter);

    this.refresh();
    this.filter.search = [];
  }

  //TODO: attenzione ora funziona perchè ricerca per id non per nome!
  findAgainCampaign(id: number) {
    // Recupera il valore corrente dall'input di filtro del nome
    const idFilter = {
      key: "id",
      value: id.toString(),
      filterType: "contains",
    };
    this.filter.search = this.filter.search.filter((f) => f.key !== "name");

    this.filter.search.push(idFilter);

    /*  this.updateTableFilter('name', id , 'contains', 1, 1000, false); */

    this.refresh();
    // Resetta i filtri dopo il refresh
    this.filter.search = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/challenge/challenge-3-kontable/challenge-3-kontable.component.ts